import { PaymentGatewayResponse } from './reservation-create-response.model';

const translatedErrorCodes = [101, 103, 200];

export class PaymentGatewayError {
  response: PaymentGatewayResponse;

  constructor(response: PaymentGatewayResponse) {
    this.response = response;
  }

  getPaymentErrorMessage() {
    return `paymentError.${this.getPaymentErrorCode(
      this.response.statusCode
    )}`;
  }

  private getPaymentErrorCode(paymentErrorCode: number) {
    return translatedErrorCodes.includes(paymentErrorCode)
      ? paymentErrorCode
      : this.getDefaultPaymentErrorCode();
  }

  private getDefaultPaymentErrorCode() {
    return 200;
  }
}
